const validEmailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const isEmailValid = email =>
  email?.match(validEmailPattern) && email?.includes('.com');
